import PropTypes from 'prop-types';
import styled from 'helpers/styles';
import ComponentStyles from 'styles/mixins/Component.styles';
import ContextPopper from 'components/molecules/Poppers/ContextPopper/ContextPopper';

const StyledTableCellPopper = styled(ContextPopper)`
  ${ComponentStyles}
`;

StyledTableCellPopper.propTypes = {
  theme: PropTypes.object
};

export default StyledTableCellPopper;
